var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIconCareers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#A0EE09",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 34C14 29.7921 17.4138 26.381 21.625 26.381C25.8362 26.381 29.25 29.7921 29.25 34H14ZM21.625 25.4286C18.4654 25.4286 15.9063 22.8714 15.9063 19.7143C15.9063 16.5571 18.4654 14 21.625 14C24.7846 14 27.3438 16.5571 27.3438 19.7143C27.3438 22.8714 24.7846 25.4286 21.625 25.4286ZM28.6427 27.5554C31.5834 28.3064 33.7944 30.8795 34 34H31.1563C31.1563 31.5145 30.2033 29.2513 28.6427 27.5554ZM26.7148 25.3875C28.271 23.9926 29.25 21.9677 29.25 19.7143C29.25 18.3644 28.8987 17.0966 28.2825 15.997C30.4655 16.4324 32.1094 18.3568 32.1094 20.6667C32.1094 23.2976 29.9768 25.4286 27.3438 25.4286C27.1305 25.4286 26.9206 25.4146 26.7148 25.3875Z",
    fill: "#A0EE09"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconCareers);
export default __webpack_public_path__ + "static/media/menu-icon-careers.77e3a179905e007c263efbb2c458586f.svg";
export { ForwardRef as ReactComponent };